import "./styles/_main.scss";
host.plugins.register({
    // #region Vars
    name: "288a.ecommerce.carts",
    // #endregion
    // #region Register
    register() {
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
        host.store.registerAll(require.context('./stores', true, /(?<!views)\.ts$/));
        host.actions.registerAll(require.context('./actions', true, /(?<!views)\.ts$/));
    }
    // #endregion
});
